import {
  Avatar as JoyAvatar,
  Menu,
  MenuButton,
  MenuItem as JoyMenuItem,
  styled,
  Theme,
} from '@mui/joy';
import { NavLink } from 'react-router-dom';

export const avatarStyle = (theme: Theme) => ({
  backgroundColor: `rgba(${theme.vars.palette.primary.mainChannel} / 0.6)`,
});

export const MenuButtonWrapper = styled(MenuButton)({
  fontWeight: 500,
  border: 'none',
  backgroundColor: 'transparent',
  paddingInline: 0,
});

export const Avatar = styled(JoyAvatar)(({ theme }) => ({
  backgroundColor: `rgba(${theme.vars.palette.primary.mainChannel} / 0.6)`,
}));

export const MenuWrapper = styled(Menu)(({ theme }) => ({
  marginRight: '24px !important',

  '& .MuiMenuItem-root:last-child': {
    borderTop: `1px solid ${theme.vars.palette.neutral[200]}`,
  },
}));

export const MenuItemWrapper = styled(JoyMenuItem)({
  display: 'flex',
  alignItems: 'center',
  height: 56,
  padding: '0 16px',
});

export const MenuItem = styled(NavLink)({
  display: 'flex',
  alignItems: 'center',
  color: 'inherit',
});
